// ConsentBanner.tsx - bandeau cookies discret (CNIL). Analytics n'est chargé
// qu'après « Accepter » ; « Refuser » ne dépose rien.
// Landmark non modal (role=region) dont le focus est déplacé à l'apparition,
// pour que les lecteurs d'écran le remarquent (à l'arrivée comme à la réouverture).
import { useEffect, useRef, type ReactElement } from "react";
import type { Path } from "../lib/router";

interface ConsentBannerProps {
  onAccept: () => void;
  onRefuse: () => void;
  navigate: (to: Path) => void;
}

export function ConsentBanner({ onAccept, onRefuse, navigate }: ConsentBannerProps): ReactElement {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <div
      className="consent"
      role="region"
      aria-label="Consentement cookies"
      tabIndex={-1}
      ref={ref}
      style={{ outline: "none" }}
    >
      <p>
        On aimerait mesurer l'audience de cette page (Google Analytics) pour savoir si
        elle est utile. Rien d'autre - vos données ne servent à aucune publicité.{" "}
        <a
          href="/confidentialite"
          onClick={(e) => {
            e.preventDefault();
            navigate("/confidentialite");
          }}
        >
          En savoir plus
        </a>
      </p>
      <div className="consent-actions">
        <button type="button" className="btn btn-ghost" onClick={onRefuse}>
          Refuser
        </button>
        <button type="button" className="btn btn-primary" onClick={onAccept}>
          Accepter
        </button>
      </div>
    </div>
  );
}
